/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Benefits_Purchase_Google_ListeningInputs */

const en_mobile_benefits_purchase_google_listening = /** @type {(inputs: Mobile_Benefits_Purchase_Google_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Purchase appears as "GOOGLEListening"`)
};

const es_mobile_benefits_purchase_google_listening = /** @type {(inputs: Mobile_Benefits_Purchase_Google_ListeningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La compra aparece como "GOOGLEListening"`)
};

/**
* | output |
* | --- |
* | "Purchase appears as \"GOOGLEListening\"" |
*
* @param {Mobile_Benefits_Purchase_Google_ListeningInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_benefits_purchase_google_listening = /** @type {((inputs?: Mobile_Benefits_Purchase_Google_ListeningInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Benefits_Purchase_Google_ListeningInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_benefits_purchase_google_listening(inputs)
	return en_mobile_benefits_purchase_google_listening(inputs)
});